import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import Detail from "../../components/common/detail/Detail";
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getDetailData} from "../../models/contactModel";
import {fetchContactById} from "../../store/contact-slice";

const ContactDetail = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const {
        items,
        fetchByIdStatus,
        error
    } = useSelector((state) => state.contact);

    useEffect(() => {
        dispatch(fetchContactById({id: params.contactId}));
    }, [dispatch, params.contactId]);

    const item = items.find(item => item.id === params.contactId);
    const detailData = getDetailData({item});

    return (
        <>
            <SubHeader title="Contact Detail">
                <Button to=".." className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" && <Detail inline={true} columns={{lg: 9, xl: 7}} data={detailData}/>}
            </div>
        </>
    )
}

export default ContactDetail